"use strict";
/**
 * zamienia pierwszą literę każdego wyrazu na wielką, pozostałe na małe
 *
 * @param value wartośc do zmiany
 */
Object.defineProperty(exports, "__esModule", { value: true });
function capitalize(value) {
    return value.toLocaleLowerCase().replace(/\w[^\s-]*/g, function (w) { return (w.replace(/^\w/, function (c) { return c.toUpperCase(); })); });
}
exports.default = capitalize;
//# sourceMappingURL=capitalize.js.map